import { Component } from '@angular/core';

@Component({
  selector: 'calsoft-header46',
  imports: [],
  templateUrl: './header46.component.html',
  styleUrl: './header46.component.scss'
})
export class Header46Component {

}
